<h2 mat-dialog-title>Edit flag value</h2>

<mat-dialog-content class="dialog-content" [formGroup]="form">
  <p class="dialog-flag">{{ data.flag.featureName }}</p>

  <mat-form-field appearance="outline" class="value-field">
    <mat-label>Value</mat-label>
    <input matInput formControlName="value" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="save()">
    Save
  </button>
</mat-dialog-actions>
